// extracted by mini-css-extract-plugin
export default {"item":"PotItem_item__UGCow","photo":"PotItem_photo__TA3bZ","info":"PotItem_info__xSReF","name":"PotItem_name__CWyI5","desc":"PotItem_desc__rkkrv"};